//
//
//
//
//
//
//
//
//
//
//
//

import '../css/style.css'
export default {
    props: [],
    data () {
        return {
            sample: ''
        }
    },
    methods: {
        queryData() {
            var sample = this.getStore('confirmSample');
            this.sample = sample ? sample.html() : '';
        }
    },
    mounted: function() {
        this.queryData();
    }
}
